module.exports = __webpack_public_path__ + "static/media/arrow-blue-finvaro.da73a316.svg";